import { jsx as _jsx } from "react/jsx-runtime";
import SettingSection from "../SettingSection";
const KeyboardShortcutsTab = () => {
    return (_jsx(SettingSection, { title: "Keyboard Shortcuts", children: _jsx("div", { className: "p-5 text-center text-gray-600", children: "Keyboard shortcuts settings coming soon..." }) }));
};
export default KeyboardShortcutsTab;
